<div class="c-site-header-inner" id="divSiteHeader">
  <div class="c-header-logo" id="divHeaderLogo">
    <img id="imgLogo" [src]="logoURL ? logoURL : 'assets/images/logo-brand-pmc.svg'" />
  </div>
  <button
    id="btnLeftPanel"
    mat-button
    class="c-left-panel-toggle-btn"
    (click)="siteLeftPanel.toggle()"
  >
    <i class="material-icons">
      menu
    </i>
  </button>
  <div class="c-site-header-left" id="divLeftHeader">
    <ul id="ulHeader">
      <li id="liHeader">
        <app-organization-popup-container
          id="comOrgPopupContainer"
        ></app-organization-popup-container>
      </li>

      <li id="liHeader" *hasPermission="[PERMISSION.ALLOW_TO_VIEW_MODULE_ICON]">
        <app-ross-popup-container id="comOrgPopupContainer"></app-ross-popup-container>
      </li>
    </ul>
  </div>
  <div class="c-site-header-right" id="divRightHeader">
    <ul>
      <li>
        <button color="secondary" mat-stroked-button [matMenuTriggerFor]="translatemenu">
          {{currentLanguage | uppercase}}<mat-icon fontIcon="translate"></mat-icon>
        </button>
        <mat-menu #translatemenu="matMenu">
          <button
            mat-menu-item
            *ngFor="let lang of translate.getLangs()"
            (click)="onLanguageSelect({ value: lang })"
          >
            {{ lang | uppercase}}
          </button>
        </mat-menu>
      </li>
      <li class="u-text-center" id="liTxt">
        <a
          href="javascript:void(0)"
          id="aProfileMenu"
          [matMenuTriggerFor]="profileMenu"
          class="c-site-header-profile-button"
        >
          <img
            matRipple
            id="imgProfile"
            [src]="userDetail && userDetail.profilePicture ? userDetail.profilePicture : '../../../../assets/images/icon-login-profile.svg'"
          />
        </a>
        <mat-menu
          id="matProfileMenu"
          #profileMenu="matMenu"
          class="c-site-header-profile-button-menu"
        >
          <div class="c-profile-content" id="divProfileContent">
            <a href="javascript:void(0)" class="c-profile-picture" id="aProfileContent">
              <img
                id="imgPicture"
                [src]="userDetail && userDetail.profilePicture ? userDetail.profilePicture : '../../../../assets/images/icon-login-profile.svg'"
              />
            </a>

            <div class="c-profile-details" id="divProfileDetails">
              <span class="c-profile-details-name" id="spnWelcome"
                >{{ "demo.welcome" | translate }}</span
              >
              <a href="#" class=" c-profile-details-email" id="aName"
                >{{userDetail?.firstName}} {{userDetail?.lastName}}</a
              >
              <a href="#" class=" c-profile-details-edit" id="ablank"></a>
              <span class=" c-profile-details-role" id="aRole"
                >{{userDetail?.userRole[0].name}}</span
              >
            </div>
          </div>

          <div class="c-profile-action" id="divAction">
            <button
              [routerLink]="['/profile']"
              id="btnProfile"
              type="button"
              *hasPermission="[PERMISSION.VIEW_PROFILE]"
            >
              {{ "demo.profile" | translate }}
            </button>
            <button type="button" (click)="signOut()" id="btnLogout">
              {{ "demo.logout" | translate }}
            </button>
          </div>
          <!-- <button mat-menu-item>Edit Profile</button>
          <button mat-menu-item>Setting</button>
          <button mat-menu-item>Logout</button> -->
        </mat-menu>
      </li>
      <!-- <li>
        <button
          class="c-notify-btn"
          id="divRtPanel"
          mat-icon-button
          (click)="siteRightPanel.toggle()"
        >
          <mat-icon id="matIconImportant">notification_important</mat-icon>
          <span id="spnActive" class="c-notify-active"></span>
        </button>
      </li> -->
      <!-- <li>
        <button mat-icon-button id="btnIcon">
          <mat-icon id="matSearch">search</mat-icon>
        </button>
      </li> -->
    </ul>
  </div>
</div>
